"use client";

const Footer = () => {
  return (
    <>
      <div className="flex-grow-1"></div>

      <footer className="footer-area bg-white text-center rounded-top-7">
        <p className="fs-14">
          © <span className="text-primary-div">MultyHealth</span> is Proudly Owned by{" "}
          <a
            href="https://multyhealth.com/"
            target="_blank"
            rel="noreferrer"
            className="text-decoration-none text-primary"
          >
            MultyHealth
          </a>
        </p>
      </footer>
    </>
  );
};

export default Footer;
